/**
 * MBTI 职业性格测试题目
 * 
 * 来源: MskTmi/MBTI (GitHub) + ziyoudeguang/MBTI-Test (场景题补充)
 * License: MIT License
 * 题目数: 93题
 * 维度分布: EI(21) / SN(26) / TF(24) / JP(22)
 * 题型分布: 场景题(64, 68.8%) / 词语题(29, 31.2%)
 * 
 * 注意:
 * - 前20题为 weight=2 核心题，保持不变
 * - 第21-93题中精选了20题替换为场景题，提升答题体验
 * - 保留经典高区分度词语题（如"温柔/坚定""思考/感受"等）
 * 
 * valueA/valueB: 标注A/B选项对应的维度字母，用于极性判断
 */

export const questions = [
  {
    id: 1,
    dimension: 'JP',
    text: '当你要外出一整天，你会',
    optionA: '计划你要做什么和在什么时候做',
    optionB: '说去就去',
    valueA: 'J',
    valueB: 'P',
    weight: 2
  },
  {
    id: 2,
    dimension: 'JP',
    text: '你认为自己是一个',
    optionA: '较为随兴所至的人',
    optionB: '较为有条理的人',
    valueA: 'P',
    valueB: 'J',
    weight: 2
  },
  {
    id: 3,
    dimension: 'SN',
    text: '假如你是一名老师，你会选教',
    optionA: '以事实为主的课程',
    optionB: '涉及理论的课程',
    valueA: 'S',
    valueB: 'N',
    weight: 2
  },
  {
    id: 4,
    dimension: 'EI',
    text: '你通常',
    optionA: '与人容易混熟',
    optionB: '比较沉静或矜持',
    valueA: 'E',
    valueB: 'I',
    weight: 2
  },
  {
    id: 5,
    dimension: 'SN',
    text: '一般来说，你和哪些人比较合得来？',
    optionA: '富于想象力的人',
    optionB: '现实的人',
    valueA: 'N',
    valueB: 'S',
    weight: 2
  },
  {
    id: 6,
    dimension: 'TF',
    text: '你是否经常让',
    optionA: '你的情感支配你的理智',
    optionB: '你的理智主宰你的情感',
    valueA: 'F',
    valueB: 'T',
    weight: 2
  },
  {
    id: 7,
    dimension: 'JP',
    text: '处理许多事情上，你会喜欢',
    optionA: '凭兴所至行事',
    optionB: '按照计划行事',
    valueA: 'P',
    valueB: 'J',
    weight: 2
  },
  {
    id: 8,
    dimension: 'EI',
    text: '你是否',
    optionA: '容易让人了解',
    optionB: '难于让人了解',
    valueA: 'E',
    valueB: 'I',
    weight: 2
  },
  {
    id: 9,
    dimension: 'JP',
    text: '按照程序表做事',
    optionA: '合你心意',
    optionB: '令你感到束缚',
    valueA: 'J',
    valueB: 'P',
    weight: 2
  },
  {
    id: 10,
    dimension: 'JP',
    text: '当你有一项特别的任务，你会喜欢',
    optionA: '开始前小心组织计划',
    optionB: '边做边找要做什么',
    valueA: 'J',
    valueB: 'P',
    weight: 2
  },
  {
    id: 11,
    dimension: 'JP',
    text: '在大多数情况下，你会选择',
    optionA: '顺其自然',
    optionB: '按程序表做事',
    valueA: 'P',
    valueB: 'J',
    weight: 2
  },
  {
    id: 12,
    dimension: 'EI',
    text: '大多数人会说你是一个',
    optionA: '重视自我隐私的人',
    optionB: '非常坦率开放的人',
    valueA: 'I',
    valueB: 'E',
    weight: 2
  },
  {
    id: 13,
    dimension: 'SN',
    text: '你宁愿被人认为是一个',
    optionA: '实事求是的人',
    optionB: '机灵的人',
    valueA: 'S',
    valueB: 'N',
    weight: 2
  },
  {
    id: 14,
    dimension: 'EI',
    text: '在一大群人当中，通常是',
    optionA: '你介绍大家认识',
    optionB: '别人介绍你',
    valueA: 'E',
    valueB: 'I',
    weight: 2
  },
  {
    id: 15,
    dimension: 'SN',
    text: '你会跟哪些人做朋友？',
    optionA: '常提出新主意的',
    optionB: '脚踏实地的',
    valueA: 'N',
    valueB: 'S',
    weight: 2
  },
  {
    id: 16,
    dimension: 'TF',
    text: '你倾向',
    optionA: '重视感情多于逻辑',
    optionB: '重视逻辑多于感情',
    valueA: 'F',
    valueB: 'T',
    weight: 2
  },
  {
    id: 17,
    dimension: 'JP',
    text: '你比较喜欢',
    optionA: '坐观事情发展才作计划',
    optionB: '很早就作计划',
    valueA: 'P',
    valueB: 'J',
    weight: 2
  },
  {
    id: 18,
    dimension: 'EI',
    text: '你喜欢花很多的时间',
    optionA: '一个人独处',
    optionB: '和别人在一起',
    valueA: 'I',
    valueB: 'E',
    weight: 2
  },
  {
    id: 19,
    dimension: 'EI',
    text: '与很多人一起会',
    optionA: '令你活力倍增',
    optionB: '常常令你心力交瘁',
    valueA: 'E',
    valueB: 'I',
    weight: 2
  },
  {
    id: 20,
    dimension: 'JP',
    text: '你比较喜欢',
    optionA: '很早便把约会、社交聚集等事情安排妥当',
    optionB: '无拘无束，看当时有什么好玩就做什么',
    valueA: 'J',
    valueB: 'P',
    weight: 2
  },
  {
    id: 21,
    dimension: 'JP',
    text: '计划一个旅程时，你较喜欢',
    optionA: '大部分的时间都是跟当天的感觉行事',
    optionB: '事先知道大部分的日子会做什么',
    valueA: 'P',
    valueB: 'J',
    weight: 1
  },
  {
    id: 22,
    dimension: 'EI',
    text: '在社交聚会中，你',
    optionA: '有时感到郁闷',
    optionB: '常常乐在其中',
    valueA: 'I',
    valueB: 'E',
    weight: 1
  },
  {
    id: 23,
    dimension: 'EI',
    text: '你通常',
    optionA: '和别人容易混熟',
    optionB: '趋向自处一隅',
    valueA: 'E',
    valueB: 'I',
    weight: 1
  },
  {
    id: 24,
    dimension: 'SN',
    text: '哪些人会更吸引你？',
    optionA: '一个思维敏捷及非常聪颖的人',
    optionB: '实事求是，具丰富常识的人',
    valueA: 'N',
    valueB: 'S',
    weight: 1
  },
  {
    id: 25,
    dimension: 'JP',
    text: '在日常工作中，你会',
    optionA: '颇为喜欢处理迫使你分秒必争的突发',
    optionB: '通常预先计划，以免要在压力下工作',
    valueA: 'P',
    valueB: 'J',
    weight: 1
  },
  {
    id: 26,
    dimension: 'EI',
    text: '你认为别人一般',
    optionA: '要花很长时间才认识你',
    optionB: '用很短的时间便认识你',
    valueA: 'I',
    valueB: 'E',
    weight: 1
  },
  {
    id: 27,
    dimension: 'EI',
    text: '请选择更合你心意的词语',
    optionA: '注重隐私',
    optionB: '坦率开放',
    valueA: 'I',
    valueB: 'E',
    weight: 1
  },
  {
    id: 28,
    dimension: 'JP',
    text: '请选择更合你心意的词语',
    optionA: '预先安排地',
    optionB: '无计划地',
    valueA: 'J',
    valueB: 'P',
    weight: 1
  },
  {
    id: 29,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '抽象',
    optionB: '具体',
    valueA: 'N',
    valueB: 'S',
    weight: 1
  },
  {
    id: 30,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '温柔',
    optionB: '坚定',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 31,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '思考',
    optionB: '感受',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 32,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '事实',
    optionB: '意念',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 33,
    dimension: 'JP',
    text: '你更喜欢',
    optionA: '灵活的时间安排',
    optionB: '固定的时间安排',
    valueA: 'P',
    valueB: 'J',
    weight: 1
  },
  {
    id: 34,
    dimension: 'EI',
    text: '在社交聚会中，你',
    optionA: '经常是最后离开的人之一',
    optionB: '经常是较早离开的人之一',
    valueA: 'E',
    valueB: 'I',
    weight: 1
  },
  {
    id: 35,
    dimension: 'EI',
    text: '你更倾向于',
    optionA: '通过交谈来思考',
    optionB: '通过思考后再交谈',
    valueA: 'E',
    valueB: 'I',
    weight: 1
  },
  {
    id: 36,
    dimension: 'JP',
    text: '你更喜欢',
    optionA: '在最后一刻完成工作',
    optionB: '提前完成工作',
    valueA: 'P',
    valueB: 'J',
    weight: 1
  },
  {
    id: 37,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '理论',
    optionB: '肯定',
    valueA: 'N',
    valueB: 'S',
    weight: 1
  },
  {
    id: 38,
    dimension: 'TF',
    text: '在团队合作中，你更看重',
    optionA: '成员之间的和谐与互相支持',
    optionB: '团队目标的客观达成',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 39,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '令人信服',
    optionB: '感人的',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 40,
    dimension: 'SN',
    text: '你通常喜欢哪一类型的作家？',
    optionA: '直截了当的',
    optionB: '运用隐喻和象征手法的',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 41,
    dimension: 'JP',
    text: '你更倾向于',
    optionA: '随遇而安',
    optionB: '凡事预则立',
    valueA: 'P',
    valueB: 'J',
    weight: 1
  },
  {
    id: 42,
    dimension: 'EI',
    text: '你更喜欢',
    optionA: '大型的社交活动',
    optionB: '小型的聚会',
    valueA: 'E',
    valueB: 'I',
    weight: 1
  },
  {
    id: 43,
    dimension: 'JP',
    text: '请选择更合你心意的词语',
    optionA: '有条不紊',
    optionB: '不拘小节',
    valueA: 'J',
    valueB: 'P',
    weight: 1
  },
  {
    id: 44,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '意念',
    optionB: '实况',
    valueA: 'N',
    valueB: 'S',
    weight: 1
  },
  {
    id: 45,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '同情怜悯',
    optionB: '远见',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 46,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '利益',
    optionB: '祝福',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 47,
    dimension: 'SN',
    text: '你比较看重',
    optionA: '事实和特性',
    optionB: '想象和创意',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 48,
    dimension: 'EI',
    text: '请选择更合你心意的词语',
    optionA: '朋友不多',
    optionB: '朋友众多',
    valueA: 'I',
    valueB: 'E',
    weight: 1
  },
  {
    id: 49,
    dimension: 'JP',
    text: '你更喜欢',
    optionA: '自由的工作方式',
    optionB: '有明确流程的工作方式',
    valueA: 'P',
    valueB: 'J',
    weight: 1
  },
  {
    id: 50,
    dimension: 'SN',
    text: '你希望被人视为',
    optionA: '一个实事求是的人',
    optionB: '一个思想创见的人',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 51,
    dimension: 'TF',
    text: '做决定时，你更看重',
    optionA: '对他人的影响',
    optionB: '逻辑的一致性',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 52,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '客观地',
    optionB: '热情地',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 53,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '建造',
    optionB: '发明',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 54,
    dimension: 'EI',
    text: '你是否经常',
    optionA: '成为聚会中的焦点',
    optionB: '在聚会中保持低调',
    valueA: 'E',
    valueB: 'I',
    weight: 1
  },
  {
    id: 55,
    dimension: 'SN',
    text: '当你尝试了解某些事情时，一般你会',
    optionA: '先要了解细节',
    optionB: '先了解整体情况，细节容后再谈',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 56,
    dimension: 'TF',
    text: '你认为做决定时',
    optionA: '应该以和为贵',
    optionB: '应该以理服人',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 57,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '具分析力',
    optionB: '多愁善感',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 58,
    dimension: 'SN',
    text: '你对下列哪方面较感兴趣？',
    optionA: '知道别人的经历，例如他们做过什么、认识什么人',
    optionB: '知道别人的想法和感受',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 59,
    dimension: 'JP',
    text: '当你要在一个星期内完成一个大项目，你在开始的时候会',
    optionA: '把要做的不同工作依次列出',
    optionB: '马上动工',
    valueA: 'J',
    valueB: 'P',
    weight: 1
  },
  {
    id: 60,
    dimension: 'EI',
    text: '在社交场合中，你经常会感到',
    optionA: '与某些人很难打开话匣儿和保持对话',
    optionB: '与多数人都能从容地长谈',
    valueA: 'I',
    valueB: 'E',
    weight: 1
  },
  {
    id: 61,
    dimension: 'SN',
    text: '要做许多人也做的事，你比较喜欢',
    optionA: '按照一般认可的方法去做',
    optionB: '构想一个自己的想法',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 62,
    dimension: 'EI',
    text: '你刚认识的朋友能否说出你的兴趣？',
    optionA: '马上可以',
    optionB: '要待他们真正了解你之后才可以',
    valueA: 'E',
    valueB: 'I',
    weight: 1
  },
  {
    id: 63,
    dimension: 'SN',
    text: '你通常较喜欢的科目是',
    optionA: '讲授概念和原则的',
    optionB: '讲授事实和数据的',
    valueA: 'N',
    valueB: 'S',
    weight: 1
  },
  {
    id: 64,
    dimension: 'TF',
    text: '哪个是较高的赞誉，或称许为？',
    optionA: '一贯感性的人',
    optionB: '一贯理性的人',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 65,
    dimension: 'JP',
    text: '你认为按照程序表做事',
    optionA: '有时是需要的，但一般来说你不大喜欢这样做',
    optionB: '大多数情况下是有帮助而且是你喜欢做的',
    valueA: 'P',
    valueB: 'J',
    weight: 1
  },
  {
    id: 66,
    dimension: 'EI',
    text: '和一群人在一起，你通常会选',
    optionA: '跟你很熟悉的个别人谈话',
    optionB: '参与大伙的谈话',
    valueA: 'I',
    valueB: 'E',
    weight: 1
  },
  {
    id: 67,
    dimension: 'EI',
    text: '在社交聚会上，你会',
    optionA: '是说话很多的一个',
    optionB: '让别人多说话',
    valueA: 'E',
    valueB: 'I',
    weight: 1
  },
  {
    id: 68,
    dimension: 'JP',
    text: '把周末期间要完成的事列成清单，这个主意会',
    optionA: '合你意',
    optionB: '使你提不起劲',
    valueA: 'J',
    valueB: 'P',
    weight: 1
  },
  {
    id: 69,
    dimension: 'TF',
    text: '哪个是较高的赞誉，或称许为',
    optionA: '能干的',
    optionB: '富有同情心',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 70,
    dimension: 'JP',
    text: '你通常喜欢',
    optionA: '事先安排你的社交约会',
    optionB: '随兴之所至做事',
    valueA: 'J',
    valueB: 'P',
    weight: 1
  },
  {
    id: 71,
    dimension: 'JP',
    text: '总的说来，要做一个大型作业时，你会选',
    optionA: '边做边想该做什么',
    optionB: '首先把工作按步细分',
    valueA: 'P',
    valueB: 'J',
    weight: 1
  },
  {
    id: 72,
    dimension: 'EI',
    text: '你能否滔滔不绝地与人聊天',
    optionA: '只限于跟你有共同兴趣的人',
    optionB: '几乎跟任何人都可以',
    valueA: 'I',
    valueB: 'E',
    weight: 1
  },
  {
    id: 73,
    dimension: 'SN',
    text: '你会',
    optionA: '跟随一些证明有效的方法',
    optionB: '分析新方法的可能性',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 74,
    dimension: 'SN',
    text: '为乐趣而阅读时，你会',
    optionA: '喜欢奇特或创新的表达方式',
    optionB: '喜欢作者直话直说',
    valueA: 'N',
    valueB: 'S',
    weight: 1
  },
  {
    id: 75,
    dimension: 'TF',
    text: '你宁愿替哪一类上司（或者老师）工作？',
    optionA: '天性淳良，但常常前后不一的',
    optionB: '言辞尖锐但永远合乎逻辑的',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 76,
    dimension: 'JP',
    text: '你做事多数是',
    optionA: '按当天心情去做',
    optionB: '照拟好的程序表去做',
    valueA: 'P',
    valueB: 'J',
    weight: 1
  },
  {
    id: 77,
    dimension: 'EI',
    text: '你是否',
    optionA: '可以和任何人按需求从容地交谈',
    optionB: '只是对某些人或在某种情况下才可以畅所欲言',
    valueA: 'E',
    valueB: 'I',
    weight: 1
  },
  {
    id: 78,
    dimension: 'TF',
    text: '要做决定时，你认为比较重要的是',
    optionA: '据事实衡量',
    optionB: '考虑他人的感受和意见',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 79,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '想象的',
    optionB: '真实的',
    valueA: 'N',
    valueB: 'S',
    weight: 1
  },
  {
    id: 80,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '仁慈慷慨的',
    optionB: '意志坚定地',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 81,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '公正的',
    optionB: '有关怀心的',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 82,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '制作',
    optionB: '设计',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 83,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '可能性',
    optionB: '必然性',
    valueA: 'N',
    valueB: 'S',
    weight: 1
  },
  {
    id: 84,
    dimension: 'TF',
    text: '在争论中，你通常',
    optionA: '容易被对方的感受所影响',
    optionB: '坚持自己的论点不被情绪左右',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 85,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '实际',
    optionB: '多愁善感',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 86,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '制造',
    optionB: '创造',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 87,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '新颖的',
    optionB: '已知的',
    valueA: 'N',
    valueB: 'S',
    weight: 1
  },
  {
    id: 88,
    dimension: 'TF',
    text: '当朋友向你倾诉烦恼时，你通常',
    optionA: '先表示理解和安慰',
    optionB: '先帮对方分析问题的原因',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 89,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '坚持己见',
    optionB: '温柔有爱心',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 90,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '具体的',
    optionB: '抽象地',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  },
  {
    id: 91,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '全心投入地',
    optionB: '有决心地',
    valueA: 'F',
    valueB: 'T',
    weight: 1
  },
  {
    id: 92,
    dimension: 'TF',
    text: '请选择更合你心意的词语',
    optionA: '能干',
    optionB: '仁慈',
    valueA: 'T',
    valueB: 'F',
    weight: 1
  },
  {
    id: 93,
    dimension: 'SN',
    text: '请选择更合你心意的词语',
    optionA: '实际',
    optionB: '创新',
    valueA: 'S',
    valueB: 'N',
    weight: 1
  }
]

// 维度权重配置
export const dimensionWeights = {
  EI: {
    core: [1, 2, 3, 4, 5],
    weights: { core: 2.0, standard: 1.0 }
  },
  SN: {
    core: [1, 2, 3, 4, 5],
    weights: { core: 2.0, standard: 1.0 }
  },
  TF: {
    core: [1, 2, 3, 4, 5],
    weights: { core: 2.0, standard: 1.0 }
  },
  JP: {
    core: [1, 2, 3, 4, 5],
    weights: { core: 2.0, standard: 1.0 }
  }
}

// 问题分类
export const questionCategories = {
  EI: {
    name: '能量方向',
    description: '探索你获取能量的方式',
    themes: [
      '社交互动',
      '人际关系',
      '独处与群居',
      '表达与倾听',
      '内向与外向'
    ]
  },
  SN: {
    name: '信息获取',
    description: '了解你处理信息的方式',
    themes: [
      '具体与抽象',
      '事实与理论',
      '现实与想象',
      '传统与创新',
      '细节与整体'
    ]
  },
  TF: {
    name: '决策方式',
    description: '探索你做决定的依据',
    themes: [
      '逻辑与情感',
      '公正与同情',
      '理性与感性',
      '客观与主观',
      '分析与应用'
    ]
  },
  JP: {
    name: '生活方式',
    description: '了解你组织生活的方式',
    themes: [
      '计划与灵活',
      '有序与随意',
      '决断与开放',
      '程序与即兴',
      '目标与过程'
    ]
  }
}